{
  "_meta": {
    "status": "REVIEWED",
    "warning": "https://app.basecamp.com/3934852/buckets/17623552/todos/9905755234#__recording_10051159377"
  },
  "common": {
    "to": "până la",
    "from": "de la"
  },
  "missing_info": {
    "clinical_history": "Ce este istoricul clinic?\n\nIstoricul clinic conține toate vizitele la medicul veterinar, atât pentru boală sau accident, cât și vizitele de rutină sau vaccinările, împreună cu data vizitei și notele veterinare corespunzătoare. Fiecare pagină a acestui document trebuie să fie numerotată, iar pe ultima pagină avem nevoie de semnătura și ștampila clinicii. Trebuie să adaugi și o certificare conform căreia vizitele înregistrate în istoric sunt singurele când animalul tău a fost la acea clinică.\n\nCum obțin istoricul clinic?\n\nFoarte simplu! Medicul veterinar îți poate furniza istoricul clinic — trebuie doar să i-l ceri. Dacă ai fost la mai mult de o clinică, va trebui să soliciți istoricul la fiecare dintre ele. Dacă ai fost la o singură clinică doar pentru vaccinare, avem totuși nevoie de istoric, care să cuprindă aceste vizite.",
    "vet_report": "Raport veterinar\n\nRaportul este un document care reflectă detaliile vizitei pentru care ne soliciți rambursarea. Acesta trebuie să conțină următoarele informații:\n    • Motivul vizitei. De exemplu: „câinele meu are dureri la lăbuță.”\n    • Simptome prezente. De exemplu: „durere la atingere, șchiopătare, umflătură la lăbuță...”\n    • Data apariției simptomelor.\n    • Investigații diagnostice efectuate. De exemplu: radiografii, examen fizic...\n    • Diagnostic. De exemplu: „traumatism prin contuzie la piciorul posterior.”\n    • Tratament. De exemplu: „repaus, cremă antiinflamatoare, medicamente...”\n    • Data programată pentru control.",
    "invoice": "Factură\n\nPentru ca o factură să fie valabilă, trebuie să conțină următoarele informații:\n    • Data emiterii facturii\n    • CUI-ul clinicii veterinare sau al farmaciei\n    • Numărul facturii\n    • Trebuie să apară cuvântul „factură”, deoarece nu acceptăm bonuri, avize de însoțire sau devize.\n    • Suma defalcată în funcție de tratamentele sau medicamentele recomandate de medicul veterinar\n\nEste posibil să fi trimis o factură corectă, dar fotografia să fie neclară, de rezoluție mică sau să existe ceva care ne împiedică să vedem bine datele facturii. Trimite-ne din nou o fotografie astfel încât să se poată citi corect.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "One single document",
              "value": "Trimite-ne factura ca un singur document, de preferință în format PDF. Așa cum ai trimis-o, nu putem urmări corect ordinea conținutului. Dacă medicul veterinar ți-a dat factura tipărită și trebuie să faci fotografii, asigură-te că se vede integral într-o singură fotografie.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Invoice complete",
              "value": "Avem nevoie de factura completă. Te rugăm să descarci factura în format PDF și să ne trimiți documentul la secțiunea facturii. Nu putem accepta facturi sub formă de mai multe capturi de ecran."
            },
            {
              "label": "Unreadable",
              "value": "Factura pe care ne-o trimiți nu se poate citi corect sau este tăiată. Te rugăm să trimiți factura completă în format PDF.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Duplicated same invoice",
              "value": "Număr de factură duplicat: ne-ai trimis anterior o factură cu același număr.\n\n<b>Fiecare factură trebuie să aibă un număr unic;</b> nu pot exista două facturi ale aceluiași emitent și din același an cu același număr.\n\nMergi la clinica ta pentru a emite o nouă factură valabilă.\n\nTrimite-ne noua factură, asigurându-te că este semnată și ștampilată de clinică.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Duplicated other invoice",
              "value": "Număr de factură duplicat: am primit deja o factură cu același număr, dar aparținând altui animal.\n\n<b>Fiecare factură trebuie să aibă un număr unic;</b> nu pot exista două facturi ale aceluiași emitent și din același an cu același număr.\n\nMergi la clinica ta pentru a emite o nouă factură valabilă.\n\nTrimite-ne noua factură, asigurându-te că este semnată și ștampilată de clinică.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "Bonul acoperă factura și nu putem citi conținutul acesteia.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Am primit o factură de la această clinică cu același număr, dar aparținând altui animal, deci nu este valabilă. Facturile trebuie să aibă un număr unic; nu pot exista două facturi de la același emitent și din același an cu același număr. Mergi la clinica ta și solicită emiterea unei facturi valabile.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "More than one pet",
              "value": "Factura pe care ne-o trimiți include cheltuieli pentru mai multe animale. Te rugăm să ne trimiți o factură separată pentru fiecare animal asigurat.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Missing invoice",
              "value": "Avem nevoie de factura pentru serviciile efectuate. Reține că pe factură trebuie să apară <b>CUI-ul</b> clinicii, <b>numărul facturii</b> și <b>data</b> la care a fost făcută cheltuiala.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Wrong pet",
              "value": "Factura pe care ne-o trimiți nu corespunde animalului asigurat.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Invoice not paid",
              "value": "Factura nu este achitată sau ai plătit doar o parte din ea. Acceptăm doar facturi plătite integral.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Not an invoice",
              "value": "Documentul pe care ni-l trimiți nu este o factură. Nu-ți face griji — pentru a o obține, întoarce-te la medicul veterinar sau la farmacie și solicită emiterea unei facturi. Trebuie să apară <b>CUI-ul</b> clinicii, <b>numărul facturii</b> și <b>data</b> la care a fost făcută cheltuiala. Conform condițiilor poliței, putem accepta doar facturi. Reține că <b>devizele, facturile proforma, facturile simplificate sau facturile cu numărul 0</b> nu sunt valabile.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Invoice number",
              "value": "De pe factura pe care ne-o trimiți lipsește numărul facturii.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "CIF",
              "value": "Documentul pe care l-ai atașat nu este o factură; te rugăm să-i ceri medicului veterinar să emită o factură adăugând CUI-ul clinicii.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Upfront payment",
              "value": "Factura pe care ne-ai trimis-o arată că ai efectuat anterior o plată parțială. Pentru a putea procesa rambursarea, avem nevoie să ne trimiți și factura aferentă primei plăți efectuate.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Am primit cererea ta de rambursare, însă nu putem accepta capturi de ecran sau fotografii ale ecranelor cu documente. Te rugăm să soliciți clinicii tale documentele în format PDF și să le atașezi prin aplicație."
            },
            {
              "label": "Signed and stamped",
              "value": "Avem nevoie să ne trimiți factura semnată și ștampilată de medicul tău veterinar.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Avem nevoie de istoricul veterinar al animalului tău de când trăiește cu tine. Solicită-l la toate clinicile la care a fost îngrijit. Trebuie să includă:\n - <b>Toate vizitele la medicul veterinar:</b> fie pentru vaccinări, controale de rutină, boli sau accidente.\n - <b>Data fiecărei vizite</b> și notele scrise de medicul veterinar.\n - <b>O confirmare că este complet:</b> medicul veterinar trebuie să scrie ceva de genul: „Nu există alte vizite înregistrate în această clinică”.\n - <b>Semnat și ștampilat de clinică.</b>\n - <b>Un istoric pentru fiecare clinică:</b> dacă ai mers la mai multe clinici, avem nevoie de un istoric de la fiecare, chiar dacă a fost doar pentru a-ți vaccina animalul.\n - <b>Nu acceptăm foi separate sau documente incomplete.</b>"
            },
            {
              "label": "Loose sheets",
              "value": "Avem nevoie să ne trimiți istoricul clinic într-un singur document. Din păcate, nu acceptăm foi separate sau dezordonate."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Ce lipsește?",
                "options": [
                  {
                    "label": "Condition",
                    "value": "Din istoric lipsește vizita legată de afecțiunea {{condicion;STRING;true}} menționată în raportul veterinar."
                  },
                  {
                    "label": "Clinic data",
                    "value": "Din istoric lipsesc unele sau toate datele clinicii. Trebuie să apară numele clinicii, CUI-ul și/sau adresa."
                  },
                  {
                    "label": "Pet details",
                    "value": "Din istoric lipsesc unele sau toate datele animalului: numele, rasa și/sau microcipul."
                  },
                  {
                    "label": "Visit dates",
                    "value": "Din istoric lipsesc următoarele date: {{fechas;DATE_RANGE;true}}"
                  },
                  {
                    "label": "Clinical notes",
                    "value": "Istoricul nu include toate notele medicului veterinar pentru fiecare vizită."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Lipsesc vizitele de la una sau mai multe clinici: {{nombre_clínica;STRING;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "Documentul pe care ni-l trimiți nu este un istoric. Solicită-l la toate clinicile la care a fost îngrijit. Trebuie să includă:\n - <b>Toate vizitele la medicul veterinar:</b> fie pentru vaccinări, controale de rutină, boli sau accidente.\n - <b>Data fiecărei vizite</b> și notele scrise de medicul veterinar.\n - <b>O confirmare că este complet:</b> medicul veterinar trebuie să scrie ceva de genul: „Nu există alte vizite înregistrate în această clinică”.\n - <b>Semnat și ștampilat de clinică.</b>\n - <b>Un istoric pentru fiecare clinică:</b> dacă ai mers la mai multe clinici, avem nevoie de un istoric de la fiecare, chiar dacă a fost doar pentru a-ți vaccina animalul.\n - <b>Nu acceptăm foi separate sau documente incomplete.</b>"
            },
            {
              "label": "Repeated attempts",
              "value": "Așa cum ți-am spus anterior, fără istoricul animalului tău nu putem procesa cererea. Solicită-l la toate clinicile la care a fost îngrijit. Trebuie să includă:\n - <b>Toate vizitele la medicul veterinar:</b> fie pentru vaccinări, controale de rutină, boli sau accidente.\n - <b>Data fiecărei vizite</b> și notele scrise de medicul veterinar.\n - <b>O confirmare că este complet:</b> medicul veterinar trebuie să scrie ceva de genul: „Nu există alte vizite înregistrate în această clinică”.\n - <b>Semnat și ștampilat de clinică.</b>\n - <b>Un istoric pentru fiecare clinică:</b> dacă ai mers la mai multe clinici, avem nevoie de un istoric de la fiecare, chiar dacă a fost doar pentru a-ți vaccina animalul.\n - <b>Nu acceptăm foi separate sau documente incomplete.</b>"
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline Explanation",
              "value": {
                "group": "Explanation",
                "options": [
                  {
                    "label": "All",
                    "value": "Cere-i medicului veterinar să includă într-un raport sau anexă la factură explicația despre cărui tratament îi corespunde fiecare poziție din factură, deoarece există poziții nespecificate. Trebuie să includă numele tratamentului și prețul acestuia.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "One or more costlines",
                    "value": "Cere-i medicului veterinar să includă într-un raport sau anexă la factură explicația despre cărui tratament îi corespund aceste poziții din factură: {{línea_de_coste;STRING;true}}. Trebuie să includă numele tratamentului și prețul acestuia.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Sessions",
              "value": "Avem nevoie de un raport cu toate sesiunile efectuate și datele acestora. Trimite-ne acest raport la finalul tratamentului, deoarece nu putem rambursa sesiuni încă neefectuate.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Changes",
              "value": "Raportul veterinar este un document oficial, prin urmare nu putem accepta modificări asupra acestuia. Avem nevoie ca medicul veterinar să ne trimită un nou raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătura, justificând modificarea efectuată.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "One document",
              "value": "Trimite-ne raportul ca un singur document, de preferință în format PDF. Așa cum l-ai trimis, nu putem urmări corect ordinea conținutului. Dacă medicul veterinar ți-a dat raportul tipărit și trebuie să faci fotografii, asigură-te că trimiți fiecare pagină într-o fotografie separată, vizibilă integral și în ordinea corectă.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Missing vet report",
              "value": {
                "group": "Ce lipsește?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Lipsește raportul veterinar de la următoarele clinici: {{clinica;STRING;true}}.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Complete Vet report",
                    "value": "Avem nevoie de raportul veterinar. Acesta trebuie să fie un document redactat de medicul veterinar care detaliază vizita pentru care soliciți rambursarea. Raportul trebuie să includă:\n\n<b>Motivul vizitei:</b> Ex: „Câinele meu are dureri la lăbuță.”\n\n<b>Simptome observate:</b> Ex: „Durere la atingere, șchiopătare, umflătură la lăbuță.”\n\n<b>Data debutului simptomelor.</b>\n\n<b>Investigații efectuate:</b> Ex: „Radiografii, examen fizic.”\n\n<b>Diagnostic:</b> Ex: „Traumatism prin contuzie la piciorul posterior.”\n\n<b>Tratament indicat:</b> Ex: „Repaus, medicamente.”\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Date",
                    "value": "Lipsește raportul veterinar pentru următoarele date: {{fecha;DATE_RANGE;true}}.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Date of symptoms",
              "value": {
                "group": "Cine trebuie să furnizeze data apariției simptomelor?",
                "options": [
                  {
                    "label": "Petparent",
                    "value": "Avem nevoie să ne indici data apariției simptomelor.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF.",
                    "type": "DATE"
                  },
                  {
                    "label": "Vet",
                    "value": "Pe raportul pe care ni-l trimiți nu apare data la care au apărut simptomele. Te rugăm să-i ceri medicului veterinar să o adauge.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Ce lipsește?",
                "options": [
                  {
                    "label": "Costline explanation",
                    "value": "Raportul veterinar nu menționează unele dintre pozițiile care apar pe factură. De exemplu, dacă factura include medicamente, dar raportul nu le indică, avem nevoie ca medicul veterinar să-l actualizeze, incluzând toate tratamentele efectuate.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Clinic data",
                    "value": "Din raport lipsesc unele sau toate datele clinicii: numele, CUI-ul și adresa.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Pet details",
                    "value": "Din raport lipsesc unele sau toate datele animalului: numele, rasa și/sau microcipul.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "Din raport lipsește diagnosticul animalului tău.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Date of visit",
                    "value": "Din raport lipsește data vizitei la medicul veterinar.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Pages",
                    "value": "Raportului pe care ni-l trimiți îi lipsesc pagini, este incomplet.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Diagnostics tests",
                    "value": "Din raport lipsesc investigațiile diagnostice (precum radiografii, analize etc.) efectuate animalului tău.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Symptoms/reason for visit",
                    "value": "Din raport lipsește motivul pentru care ai mers la consultul veterinar, adică o descriere clară a simptomelor prezentate de animalul tău.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Treatment",
                    "value": "Din raport lipsește tratamentul prescris animalului tău.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Inconsistency between documents",
              "value": "Am detectat următoarele inconsecvențe în documentele pe care ni le trimiți: {{inconsistency;STRING;true}}. Avem nevoie de o clarificare din partea medicului veterinar într-un raport.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Previous related reports",
              "value": "Avem nevoie de rapoartele vizitelor anterioare legate de această afecțiune. În acestea trebuie să fie indicate simptomele, data debutului, investigațiile efectuate, tratamentele recomandate și evoluția. Dacă îți este mai ușor, ne poți trimite istoricul clinic complet.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Previous visits",
              "value": "Avem nevoie să ne trimiți rapoartele anterioare legate de vizită.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Cere-i medicului veterinar să indice într-un raport sau anexă la factură fiecare serviciu sau tratament efectuat animalului și prețul în mod individual.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Raportul pe care ni-l trimiți nu corespunde facturii. Te rugăm să te asiguri că raportul are aceeași dată cu factura și că include pozițiile facturate.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Unreadable",
              "value": "Raportul veterinar pe care ni-l trimiți nu se poate citi corect sau este tăiat. Te rugăm să trimiți raportul complet în format PDF.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Not a vet report",
              "value": "Documentul pe care ni l-ai trimis nu este un raport veterinar. Acesta trebuie să fie un document redactat de medicul veterinar care detaliază vizita pentru care soliciți rambursarea. Raportul trebuie să includă:\n - <b>Motivul vizitei:</b> Ex: „Câinele meu are dureri la lăbuță.”\n - <b>Simptome observate:</b> Ex: „Durere la atingere, șchiopătare, umflătură la lăbuță.”\n - <b>Data debutului simptomelor.</b>\n - <b>Investigații efectuate:</b> Ex: „Radiografii, examen fizic.”\n - <b>Diagnostic:</b> Ex: „Traumatism prin contuzie la piciorul posterior.”\n - <b>Tratament indicat:</b> Ex: „Repaus, medicamente.”.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Chronic condition",
              "value": "Pentru rambursarea medicamentelor pentru afecțiuni cronice, avem nevoie de un raport de monitorizare al medicului veterinar, care să explice starea animalului tău și evoluția tratamentului. Acest raport trebuie actualizat la fiecare 6 luni.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Treatment recommendation",
              "value": "În documentul pe care ni-l trimiți vedem tratamentele recomandate de medicul veterinar, dar avem nevoie de un raport complet al vizitei.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Avem nevoie să ne trimiți raportul semnat și ștampilat de medicul tău veterinar.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Am primit cererea dumneavoastră de rambursare, însă nu putem accepta capturi de ecran sau fotografii ale ecranelor cu documente. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF și să le atașați prin aplicație."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Certificado de alta del chip",
              "value": "Avem nevoie să ne trimiți certificatul de înregistrare al microcipului animalului tău."
            },
            {
              "label": "Contrato de compra o adopción",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Falta",
                    "value": "Avem nevoie să ne trimiți contractul de cumpărare sau de adopție al animalului tău."
                  },
                  {
                    "label": "No es legible",
                    "value": "Contract de cumpărare sau adopție: documentul pe care ni-l trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Avem nevoie de numărul tău IBAN",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ecografie: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de raportul original al ecografiei efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Ecografia pe care ni-o trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "Echocardiography",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ecocardiografie: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de raportul original al ecocardiografiei efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Ecocardiografia pe care ni-o trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Radiografie: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie să ne atașezi radiografiile efectuate cu filigran original sau în format DICOM (.dcm)."
                  },
                  {
                    "label": "Original documents",
                    "value": "Avem nevoie de imaginile originale ale radiografiei efectuate. Acestea pot fi în format DICOM (.dcm). Acest format este, pentru radiografii, similar cu jpg pentru fotografii. Chiar dacă tu nu le poți deschide, noi le putem deschide."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Radiografia pe care ni-o trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "RMN: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de raportul original al RMN-ului efectuat. Raportul trebuie să includă datele animalului și data efectuării investigației."
                  },
                  {
                    "label": "Unreadable",
                    "value": "RMN-ul pe care ni-l trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "TAC",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "CT: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de raportul original al CT-ului efectuat. Raportul trebuie să includă datele animalului și data efectuării investigației."
                  },
                  {
                    "label": "Unreadable",
                    "value": "CT-ul pe care ni-l trimiți nu se poate citi corect."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Analytics",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Analize: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de rezultatele sau de documentul original al analizelor efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultatele analizelor pe care ni le trimiți nu se pot citi corect.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Biopsie: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de rezultatele sau de documentul original al biopsiei efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultatele biopsiei pe care ni le trimiți nu se pot citi corect.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Citology",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Citologie: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de rezultatele sau de documentul original al citologiei efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultatele citologiei pe care ni le trimiți nu se pot citi corect.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Urine test",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Analiză de urină: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie de rezultatele sau de documentul original al analizei de urină efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezultatele analizei de urină pe care ni le trimiți nu se pot citi corect.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document. La secțiunea de note îți vom indica unde am observat o modificare nejustificată."
                  },
                  {
                    "label": "Missing",
                    "value": "Avem nevoie să ne trimiți o fotografie a carnetului sau a pașaportului unde apar datele animalului și toate vaccinurile pe care le-a primit."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Documentul pe care ni-l trimiți nu se poate citi corect."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "Avem nevoie să ne trimiți o fotografie a carnetului sau a pașaportului unde apare numărul de microcip al animalului."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Carnet de vaccinare: avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document."
            },
            {
              "label": "Missing",
              "value": "Avem nevoie să ne trimiți o fotografie a carnetului sau a pașaportului unde apar acest vaccin și toate vaccinurile aplicate."
            },
            {
              "label": "Unreadable",
              "value": "Carnetul de vaccinare pe care ni-l trimiți nu se poate citi corect."
            },
            {
              "label": "Chipnumber",
              "value": "Avem nevoie să ne trimiți o fotografie a carnetului sau a pașaportului unde apare numărul de microcip al animalului."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Avem nevoie de istoricul veterinar al animalului tău de când trăiește cu tine. Solicită-l la toate clinicile la care a fost îngrijit. Trebuie să includă:\n - <b>Toate vizitele la medicul veterinar:</b> fie pentru vaccinări, controale de rutină, boli sau accidente.\n - <b>Data fiecărei vizite</b> și notele scrise de medicul veterinar.\n - <b>O confirmare că este complet:</b> medicul veterinar trebuie să scrie ceva de genul: „Nu există alte vizite înregistrate în această clinică”.\n - <b>Semnat și ștampilat de clinică.</b>\n - <b>Un istoric pentru fiecare clinică:</b> dacă ai mers la mai multe clinici, avem nevoie de un istoric de la fiecare, chiar dacă a fost doar pentru a-ți vaccina animalul.\n - <b>Nu acceptăm foi separate sau documente incomplete.</b>"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Missing",
              "value": "Avem nevoie de raportul original al investigației efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației."
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Missing",
              "value": "Avem nevoie de raportul original al analizelor efectuate. Raportul trebuie să includă datele animalului și data efectuării investigației.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Chip registration certificate",
              "value": "Avem nevoie să ne trimiți certificatul de înregistrare al microcipului animalului tău."
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "Ce se întâmplă?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Avem nevoie să ne trimiți contractul de cumpărare sau de adopție al animalului tău."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Contract de cumpărare sau adopție: documentul pe care ni-l trimiți nu se poate citi corect."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Avem nevoie de numărul tău IBAN",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Complete invoice",
              "value": "Avem nevoie de factura completă. Te rugăm să descarci factura în format PDF și să ne trimiți documentul la secțiunea facturii. Nu putem accepta facturi sub formă de mai multe capturi de ecran."
            },
            {
              "label": "CIF",
              "value": "De pe factura pe care ne-o trimiți lipsește CUI-ul sau este incomplet.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Invoice number",
              "value": "De pe factura pe care ne-o trimiți lipsește numărul facturii sau este incomplet.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Receipt covers the invoice",
              "value": "Bonul acoperă factura sau o parte din ea și nu putem citi conținutul acesteia.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Am primit o factură de la această clinică cu același număr, dar aparținând altui animal, deci nu este valabilă. Facturile trebuie să aibă un număr unic; nu pot exista două facturi de la același emitent și din același an cu același număr. Mergi la clinica ta și solicită emiterea unei facturi valabile.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "More than one pet",
              "value": "Factura pe care ne-o trimiți include costuri asociate mai multor animale. Te rugăm să ne trimiți o factură separată pentru fiecare animal asigurat.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Missing",
              "value": "Avem nevoie de factura pentru serviciile efectuate. Reține că pe factură trebuie să apară <b>CUI-ul</b> clinicii, <b>numărul facturii</b> și <b>data</b> la care a fost făcută cheltuiala.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Unreadable",
              "value": "Factura pe care ne-o trimiți nu se poate citi corect sau este tăiată. Te rugăm să trimiți factura completă în format PDF.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Not an invoice",
              "value": "Documentul pe care ni-l trimiți nu este o factură. Nu-ți face griji — pentru a o obține, întoarce-te la medicul veterinar sau la farmacie și solicită emiterea unei facturi. Trebuie să apară <b>CUI-ul</b> clinicii, <b>numărul facturii</b> și <b>data</b> la care a fost făcută cheltuiala. Conform condițiilor poliței, putem accepta doar facturi. Reține că <b>devizele, facturile proforma, facturile simplificate sau facturile cu numărul 0</b> nu sunt valabile.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "One single document",
              "value": "Trimite-ne factura ca un singur document, de preferință în format PDF. Așa cum a fost trimisă, nu putem urmări corect ordinea conținutului. Dacă medicul veterinar ți-a dat factura tipărită și trebuie să îi faci poze, asigură-te că se vede în întregime într-o singură fotografie.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Am primit cererea ta de rambursare, însă nu putem accepta capturi de ecran sau fotografii ale ecranelor cu documente. Te rugăm să soliciți clinicii tale documentele în format PDF și să le atașezi prin aplicație."
            },
            {
              "label": "Signed and stamped",
              "value": "Avem nevoie să ne trimiți factura semnată și ștampilată de medicul tău veterinar.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline explanation",
              "value": "Cere-i medicului veterinar să includă într-un raport sau anexă la factură explicația despre cărui tratament îi corespund aceste poziții din factură: {{línea_de_coste;STRING;true}}. Trebuie să includă numele tratamentului și prețul acestuia.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Changes",
              "value": "Avem nevoie ca medicul veterinar să redacteze un raport ștampilat, cu numele complet, numărul de înregistrare profesională și semnătură, explicând de ce s-a produs o modificare în document.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Ce lipsește?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Lipsește raportul veterinar de la următoarele clinici: {{clinica;STRING;true}}.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "All",
                    "value": "Avem nevoie de raportul veterinar. Acesta trebuie să fie un document redactat de medicul veterinar care detaliază vizita pentru care soliciți rambursarea. Raportul trebuie să includă:\n\n<b>Motivul vizitei:</b> Ex: „Câinele meu are dureri la lăbuță.”\n\n<b>Simptome observate:</b> Ex: „Durere la atingere, șchiopătare, umflătură la lăbuță.”\n\n<b>Data debutului simptomelor.</b>\n\n<b>Investigații efectuate:</b> Ex: „Radiografii, examen fizic.”\n\n<b>Diagnostic:</b> Ex: „Traumatism prin contuzie la piciorul posterior.”\n\n<b>Tratament indicat:</b> Ex: „Repaus, medicamente.”\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  },
                  {
                    "label": "Dates",
                    "value": "Lipsește raportul veterinar pentru următoarele date: {{fecha;DATE_RANGE;true}}.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
                  }
                ]
              }
            },
            {
              "label": "Not a vet report",
              "value": "Documentul pe care ni l-ai trimis nu este un raport veterinar. Acesta trebuie să fie un document redactat de medicul veterinar care detaliază vizita pentru care soliciți rambursarea. Raportul trebuie să includă:\n - <b>Motivul vizitei:</b> Ex: „Câinele meu are dureri la lăbuță.”\n - <b>Simptome observate:</b> Ex: „Durere la atingere, șchiopătare, umflătură la lăbuță.”\n - <b>Data debutului simptomelor.</b>\n - <b>Investigații efectuate:</b> Ex: „Radiografii, examen fizic.”\n - <b>Diagnostic:</b> Ex: „Traumatism prin contuzie la piciorul posterior.”\n - <b>Tratament indicat:</b> Ex: „Repaus, medicamente.”.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Cere-i medicului veterinar să indice într-un raport sau anexă la factură fiecare serviciu sau tratament efectuat animalului și prețul în mod individual.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Raportul pe care ni-l trimiți nu corespunde facturii. Facturile trebuie să fie întotdeauna corelate cu rapoartele.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Unreadable",
              "value": "Raportul veterinar pe care ni-l trimiți nu se poate citi corect sau este tăiat. Te rugăm să trimiți raportul complet în format PDF.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Avem nevoie să ne trimiți raportul semnat și ștampilat de medicul tău veterinar.\n\nNu putem accepta capturi de ecran sau fotografii ale ecranelor documentelor. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Am primit cererea dumneavoastră de rambursare, însă nu putem accepta capturi de ecran sau fotografii ale ecranelor cu documente. Vă rugăm să solicitați clinicii dumneavoastră documentele în format PDF și să le atașați prin aplicație."
            }
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
        "group": "Waiting period",
        "options": [
          {
            "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "După analizarea documentației lui {{petName}}, te informăm că factura ta, sau o parte a acesteia, nu a putut fi aprobată. Polița ta are o perioadă de așteptare de 5 zile pentru accidente de la data încheierii contractului. În acest caz, afecțiunea indicată: {{condition;STRING;true}}, a apărut sau a primit îngrijiri veterinare la: {{date;DATE;true}}, în aceste 5 zile. Din acest motiv, nu este acoperită de asigurare și este considerată preexistentă. Dacă această afecțiune se prelungește în timp sau reapare în viitor în mod recurent sau cronic, nici acest episod, nici eventualele recidive sau complicații rezultate din acesta nu vor putea fi rambursate, indiferent de data diagnosticului definitiv."
          },
          {
            "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "După ce am verificat documentația lui {{petName}}, te informăm că factura ta, sau o parte a acesteia, nu a putut fi aprobată. Polița ta are o perioadă de așteptare de 28 de zile pentru boli de la data încheierii contractului. Polița definește o listă specifică de situații cu perioadă de așteptare redusă de 5 zile, iar această afecțiune, din păcate, nu se numără printre ele, astfel că se aplică perioada generală de așteptare de 28 de zile. În acest caz, afecțiunea indicată: {{condition;STRING;true}}, a apărut sau a primit îngrijiri veterinare la: {{date;DATE;true}}, în aceste 28 de zile, și este clasificată drept boală, deoarece nu îndeplinește condițiile stabilite de poliță pentru a fi considerată accident. Din acest motiv, nu este acoperită de asigurare și este considerată preexistentă. Dacă această afecțiune se prelungește în timp sau reapare în viitor în mod recurent sau cronic, nici acest episod, nici eventualele recidive sau complicații rezultate din acesta nu vor putea fi rambursate, indiferent de data diagnosticului definitiv."
          },
          {
            "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
                        "value": "După analizarea documentației lui {{petName}}, te informăm că factura ta, sau o parte a acesteia, nu a putut fi aprobată. Polița ta prevede o perioadă de așteptare de 6 luni pentru anumite afecțiuni de la data încheierii contractului. Printre aceste afecțiuni se numără: displazia de șold, displazia de cot, ruptura sau afecțiunea ligamentului încrucișat, luxația rotulei, atopia, dermatita alergică, epilepsia, tulburările de comportament, leishmanioza, cataracta și hernia de disc. Dacă animalul avea peste 6 luni la momentul încheierii poliței, aceste afecțiuni sunt supuse acestei perioade de 6 luni, chiar dacă originea lor ar putea fi legată de un eveniment neprevăzut. În acest caz, afecțiunea indicată: {{condition;STRING;true}}, a apărut sau a fost tratată la: {{date;DATE;true}}, în această perioadă de 6 luni. Prin urmare, nu este acoperită de asigurare și este considerată preexistentă. Această afecțiune va rămâne exclusă din acoperire și în viitor: întrucât primele simptome sau prima vizită veterinară aferentă au avut loc în perioada de așteptare a poliței, nu putem aproba viitoare cereri de rambursare legate de această afecțiune sau de orice simptom, leziune sau boală care derivă din aceasta. Această afecțiune va fi considerată permanent preexistentă, chiar dacă diagnosticul definitiv este confirmat ulterior."
          }
        ]
      },
      {
        "group": "Preexistence",
        "options": [
          {
            "label": "Preexistence/before contract",
                        "value": "După analizarea documentației lui {{petName}}, te informăm că factura ta, sau o parte a acesteia, nu a putut fi aprobată.\n\nAfecțiunea pe care o prezintă animalul tău: {{condition;STRING;true}}, este considerată preexistentă, deoarece a apărut, a prezentat simptome sau a fost tratată pentru prima dată la: {{date;DATE;true}}, înainte de începerea acoperirii.\n\nO afecțiune preexistentă este orice leziune sau boală care: a apărut sau a prezentat simptome clinice înainte de începerea acoperirii poliței, sau are același diagnostic sau aceleași simptome ca o leziune sau boală pe care animalul o avea deja înainte de începerea acoperirii, sau este cauzată de, legată de sau derivă dintr-o leziune, boală sau simptom clinic anterior începerii acoperirii.\n\nÎn plus, această afecțiune va rămâne exclusă din acoperire și în viitor. Aceasta înseamnă că nu putem aproba viitoare cereri de rambursare legate de această afecțiune sau de orice simptom, leziune sau boală care derivă din aceasta, chiar dacă diagnosticul definitiv este confirmat ulterior."
          },
          {
            "label": "Same diagnosis in different body part",
            "value": "Reține că, în conformitate cu condițiile poliței tale, dacă animalul tău a suferit înainte de începerea acoperirii sau în perioada de așteptare de: (hernie sau protruzie discală, ruptură sau boală a ligamentului încrucișat, luxație de rotulă, displazie de cot sau șold, cataractă sau osteoartrită), nu vor fi rambursate cheltuielile legate de aceeași patologie, chiar dacă ulterior se manifestă într-o altă parte a corpului.\n\nDe exemplu, aceasta include: o hernie sau protruzie discală într-un alt disc intervertebral, o ruptură sau boală a ligamentului încrucișat la un alt picior."
          },
          {
            "label": "Date outside coverage period",
            "value": "Factură anterioară încheierii poliței: din păcate, cererea ta de rambursare a fost respinsă, deoarece data facturii pe care ne-o trimiți este anterioară datei de începere a poliței."
          },
          {
            "label": "Not an accident denial",
            "value": "Am analizat solicitarea dumneavoastră și, în conformitate cu Condițiile Generale ale poliței, acest caz nu poate fi considerat un Accident în scopul acordării acoperirii.\n\nPolița prevede că, pentru ca un caz să fie considerat Accident, acesta trebuie să îndeplinească definiția accidentului prevăzută în contract și, în plus, să se încadreze exclusiv în una dintre următoarele situații:\n\nFracturi sau luxații articulare cauzate de un traumatism.\nLacerații ale pielii, răni provocate prin mușcătură (cu excepția înțepăturilor de insecte) sau escoriații.\nArsuri sau leziuni provocate de electrocutare.\nTraumatisme provocate de vehicule.\nIntoxicații.\nRăni provocate de arme de foc sau proiectile.\nContuzii grave sau leziuni prin strivire.\nLeziuni dentare traumatice.\nCorpi străini gastrointestinali.\n\nÎn plus, Condițiile Generale prevăd în mod expres că leziunile sau afecțiunile care, chiar dacă sunt asociate unui eveniment traumatic, corespund unei patologii pentru care contractul prevede o perioadă specifică de așteptare sunt supuse acelei perioade de așteptare și nu celei aplicabile Accidentelor.\n\nDin acest motiv, în acest caz se aplică perioada de așteptare de 28 de zile, și nu perioada de 5 zile aplicabilă Accidentelor.\n\nÎntrucât simptomele și/sau tratamentul au avut loc în această perioadă de așteptare, din păcate nu putem rambursa cheltuielile aferente."
          }
        ]
      },
      {
        "group": "Vaccinations are not up to date",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "Vaccinarea anuală nu este la zi. Conform condițiilor generale ale poliței tale, animalul tău trebuie să fie la zi cu vaccinurile împotriva următoarelor boli: rabie, jigodie, hepatită și parvoviroză. În acest caz, schema de vaccinare nu este completă sau nu s-au respectat indicațiile medicului veterinar. Nu putem acoperi cheltuielile veterinare care decurg din dezvoltarea acestei boli."
          }
        ]
      },
      {
        "group": "Disclaimer",
        "options": [
          {
            "label": "Disclaimer Clinical history",
            "value": "Istoric clinic. Vreau să-ți reamintesc că la următoarea cerere de rambursare avem nevoie să ne trimiți istoricul clinic al animalului tău. Istoricul clinic conține, într-un singur document, toate vizitele la medicul veterinar, atât pentru boală sau accident, cât și vizitele de rutină sau vaccinările, împreună cu data vizitei și notele veterinare corespunzătoare. Dacă animalul a fost la mai multe clinici, trebuie să soliciți istoricul la toate. Fiecare pagină a acestui document trebuie să fie numerotată, iar pe ultima pagină avem nevoie de semnătura și ștampila clinicii. Trebuie să adaugi și o certificare conform căreia vizitele înregistrate în istoric sunt singurele când animalul tău a fost la acea clinică."
          },
          {
            "label": "More than one pet",
            "value": "Pentru a accelera procesarea cererilor viitoare, recomandăm ca fiecare factură să corespundă unui singur animal. Facturile care includ cheltuieli pentru mai multe animale pot conduce la solicitarea de informații suplimentare."
          },
          {
            "label": "Complementary sessions limit reacheds",
            "value": "Te informăm că ai folosit deja cele 8 sesiuni/tratamente complementare incluse în perioada în vigoare a contractului tău."
          },
          {
            "label": "Annual visit limit reached",
            "value": "Ai folosit deja vizita anuală acoperită de polița ta."
          },
          {
            "label": "Unjustified costlines",
            "value": "Unele dintre costurile indicate nu sunt suficient justificate în documentația furnizată și, prin urmare, nu pot fi evaluate conform condițiilor asigurării."
          },
          {
            "label": "Outside EU, UK and Andorra",
            "value": "Polița ta nu acoperă cheltuielile efectuate în afara Uniunii Europene, Regatului Unit și Andorrei."
          },
          {
            "label": "Disclaimer chronic condition revision",
            "value": "Raport de control. Îți reamintim că, pentru a putea rambursa medicamentele cronice, este necesară o vizită de control la fiecare 6 luni. Avem nevoie să ne trimiți raportul controlului cu următoarea cerere."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "În conformitate cu Condițiile Generale ale poliței tale, sunt excluse transplanturile (inclusiv îngrijirile pre- și postoperatorii), stimulatoarele cardiace (pacemakere), protezele, implanturile (cu excepția implanturilor de osteosinteză), precum și părțile artificiale ale corpului sau articulațiile artificiale."
          }
        ]
      },
      {
        "group": "Preventative/routinary costline",
        "options": [
          {
            "label": "Preventative/routinary costline",
            "value": "Tratament preventiv. Asigurarea Barkibu acoperă doar cheltuielile veterinare care apar ca urmare a unei boli sau a unui accident. Cheltuielile pe care ni le trimiți sunt legate de tratamente de rutină sau preventive, deci nu sunt acoperite."
          }
        ]
      },
      {
        "group": "Postmortem",
        "options": [
          {
            "label": "Our condolences",
            "value": "Vreau să-ți transmit, din partea întregii echipe Barkibu, toată puterea posibilă în aceste momente atât de grele. Ne pare foarte rău pentru ceea ce s-a întâmplat."
          }
        ]
      },
      {
        "group": "Prevention outside of country",
        "options": [
          {
            "label": "Prevention outside of country",
            "value": "Polița ta de prevenție are acoperire doar în România."
          }
        ]
      },
      {
        "group": "Shunt/congenital malformation",
        "options": [
          {
            "label": "Shunt/congenital malformation",
            "value": "Conform condițiilor generale, nu sunt acoperite cheltuielile legate de anastomozele vasculare patologice congenitale și de malformațiile cardiace congenitale (de exemplu, shunt portosistemic sau PDA), chiar dacă nu erau cunoscute la momentul încheierii poliței."
          }
        ]
      },
      {
        "group": "Brachycephalic Syndrome",
        "options": [
          {
            "label": "Brachycephalic Syndrome",
            "value": "Sindromul brahicefalic este exclus de la acoperire conform celor stabilite în Condițiile Generale ale poliței. În consecință, cheltuielile care decurg din diagnosticul și tratamentul acestuia nu pot fi rambursate."
          }
        ]
      },
      {
        "group": "Annual limit reached",
        "options": [
          {
            "label": "Annual limit reached",
            "value": "Te informăm că ai atins limita anuală a poliței tale."
          }
        ]
      },
      {
        "group": "Prevention",
        "options": [
          {
            "label": "Vaccinations not covered",
            "value": "Vaccin neacoperit: pachetul de îngrijire preventivă al asigurării tale veterinare include vaccinul antirabic, polivalent și împotriva tusei de cușcă pentru câini, și vaccinul antirabic, trivalent și împotriva leucemiei pentru pisici."
          },
          {
            "label": "Annual visit with tests",
            "value": "Vizită anuală cu analize: pachetul de îngrijire preventivă al asigurării tale veterinare include o vizită preventivă anuală, care să nu fie legată de o boală, accident sau simptom al animalului. Această vizită nu include investigațiile sau analizele care i se pot face animalului. Vizita pe care ne-o trimiți nu îndeplinește aceste cerințe, prin urmare nu este acoperită."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Închiderea cererii",
        "options": [
          {
            "label": "Missing information",
            "value": "Am închis cererea ta deoarece documentația primită nu este suficientă pentru a o evalua. Ți-am indicat prin aplicație documentele necesare, dar nu le-am primit corect. Dacă dorești ca cererea să fie verificată din nou, te rugăm să creezi o cerere nouă incluzând toate informațiile solicitate."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Am închis această cerere deoarece este legată de o altă cerere care încă este deschisă și în așteptarea documentelor de la tine. Trebuie să încarci documentele solicitate direct în cererea care apare în aplicație ca „Lipsesc documente”."
          },
          {
            "label": "Duplicated invoice",
            "value": "Am închis cererea ta deoarece, după ce am verificat din nou facturile, am constatat că acestea au fost deja incluse într-o cerere anterioară."
          },
          {
            "label": "Erroneous pet",
            "value": "Am închis cererea ta deoarece cheltuielile prezentate nu corespund animalului asigurat în această poliță."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Am închis cererea ta deoarece polița ta este în prezent suspendată. Am încercat să te contactăm de mai multe ori pentru a actualiza plata și a încasa primele restante, dar fără succes. Odată ce situația va fi regularizată, vei putea trimite o nouă cerere din aplicație."
          },
          {
            "label": "Pet parent asked to close the claim",
            "value": "Am închis cererea ta deoarece ne-ai cerut acest lucru."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Din cauza neconcordanțelor identificate în cererile de rambursare anterioare, de acum înainte toate documentele pentru rambursările viitoare trebuie trimise direct de către clinica ta veterinară la clinic@barkibu.com.\n\nDupă ce clinica ta le-a trimis, este important să deschizi o nouă cerere prin aplicație cu aceleași documente, adăugând mențiunea: „Clinica mea a trimis deja documentele\", pentru a le putea verifica.\n\nTe rugăm ca, pentru a facilita gestionarea rambursărilor tale, să nu creezi niciodată o cerere cu documente care nu ne-au fost trimise în prealabil de clinica ta la adresa de e-mail indicată mai sus."
          },
          {
            "label": "No response from clinic",
            "value": "Am închis cererea ta deoarece, cu documentele furnizate până acum, nu dispunem de suficiente informații pentru a emite o evaluare. Am încercat de mai multe ori să contactăm clinica ta pentru a completa informațiile, însă fără succes.\n\nPentru a putea analiza cererile tale, contactează clinica ta pentru ca aceasta să își verifice e-mailul.\n\nOdată ce ne-au răspuns, vei putea redeschide cererea prin aplicație."
          },
          {
            "label": "Fraud",
            "value": "După analizarea documentației prezentate, am identificat neconcordanțe care ne împiedică să aprobăm cererea dumneavoastră.\n\nDe acum înainte, toată documentația pentru rambursările viitoare va trebui trimisă direct de către clinica dumneavoastră veterinară la clinic@barkibu.com.\n\nDupă ce clinica dumneavoastră a trimis-o, este important să redeschideți o cerere prin aplicație cu aceleași documente, adăugând nota: „Clinica mea a trimis deja documentația\", pentru a o putea analiza.\n\nVă rugăm, pentru a facilita gestionarea rambursărilor dumneavoastră, să nu creați niciodată o cerere cu documente care nu ne-au fost trimise în prealabil de către clinica dumneavoastră la adresa de e-mail indicată mai sus."
          }
        ]
      }
    ]
  }
}
